
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import ToolReportingNoResults from './tool-reporting/no-results.component.vue'

export default defineComponent({
  name: 'InsightsNoResults',
  components: {
    ToolReportingNoResults,
  },
  props: {
    noResults: {
      type: Boolean,
      required: true,
    },
    align: {
      type: String as PropType<'start' | 'center' | 'end'>,
      default: 'center',
    },
  },
  setup(props) {
    const baseClass = 'epb-insights-no-results'

    const justifyContentStyle = computed(() => {
      return props.align === 'start' ? 'flex-start' : props.align === 'end' ? 'flex-end' : 'center'
    })

    return {
      baseClass,
      justifyContentStyle,
    }
  },
})
